import { Flex } from "@mantine/core";

type IProps = {
  children: React.ReactNode;
  maxWidth?: string;
  flex?: number;
  disabled?: boolean;
};

export default function CardBoxShadow({
  children,
  maxWidth = "600px",
  flex = 1,
  disabled = false,
}: IProps) {
  return (
    <Flex
      maw={{
        base: "100%",
        1300: maxWidth,
      }}
      miw={{ base: "100%", 991: "250px", 1400: "350px" }}
      bg="white"
      style={{
        flexGrow: flex,
        boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.05)",
        filter: disabled ? "grayscale(1)" : "none",
        opacity: disabled ? 0.8 : 1,
      }}
    >
      {children}
    </Flex>
  );
}
